module.exports = function() {
    const cities = [
        {
            name: 'london',
            date: new Date().toLocaleString("en-US", {timeZone: "Europe/London"})
        },
        {
            name: 'newyork',
            date: new Date().toLocaleString("en-US", {timeZone: "America/New_York"})
        }, 
        {
            name: 'singapore',
            date: new Date().toLocaleString("en-US", {timeZone: "Asia/Singapore"})
        }
    ]

    for (let index = 0; index < cities.length; index++) {
        const   now       = new Date(cities[index]['date']),
                hourDeg   = now.getHours() / 12 * 360 + now.getMinutes() / 60 * 30,
                minuteDeg = now.getMinutes() / 60 * 360 + now.getSeconds() / 60 * 6,
                secondDeg = now.getSeconds() / 60 * 360;

        if ( document.querySelector('[data-city='+cities[index]['name']+']') ) {
            document.querySelector('[data-city='+cities[index]['name']+']').querySelector('.clock-icon__hours').setAttribute("style", "transform: rotate("+hourDeg+"deg)");
            document.querySelector('[data-city='+cities[index]['name']+']').querySelector('.clock-icon__minutes').setAttribute("style", "transform: rotate("+minuteDeg+"deg)");
        }

    }
};